module.exports = __webpack_public_path__ + "static/media/music1.9bbad32e.mp3";